import React, { useContext, useState, useEffect } from "react";
import { Form, Input, Button, Message } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { AppContext } from "../../../Context/AppContext";
import logo from "../../../logo.png";
import "./Login.css";
import { getAllUsers, loginUser, getAppVersion } from "../../../constants";

const Login = (appProps) => {
  /* VARIABLE DECLARATIONS
	---------------------------------------------------------------------------------*/
  const { userInfo, appVersion, isAppVersionOutdated } = useContext(AppContext);
  const [user, setUser] = userInfo;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const [var_app_version, set_var_app_version] = appVersion;
  const [password, setPassword] = useState();
  const [email, setEmail] = useState();
  const [validation_error, setValidationError] = useState();
  const [isError, setISError] = useState();
  const [isLoading, setLoading] = useState(false);
  const homescreen = useHistory();

  /* Async functions
	---------------------------------------------------------------------------------*/

  /* EVENT LISTENERS
	---------------------------------------------------------------------------------*/
  useEffect(() => {
    getVersion();
  }, []);

  /* EVENT FUNCTIONS
	---------------------------------------------------------------------------------*/
  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };

  function validate() {
    if (!email) {
      setValidationError("Please write valid email");
      setISError(true);
      return false;
    } else if (!password) {
      setValidationError("Please write password");
      setISError(true);
      return false;
    } else {
      setISError(false);
      return true;
    }
  }

  const getVersion = async () => {
    await fetch(getAppVersion)
      .then((response) => response.json())
      .then((res) => {
        if (res.code === 200) {
          localStorage.setItem("AppVersion", res.version);
          set_var_app_version(res.version);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const onSubmit = async () => {
    setLoading(true);
    if (validate()) {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          appversion: var_app_version,
        },
        body: JSON.stringify({ email, password, is_role: "scheduler" }),
      };
      await fetch(loginUser, requestOptions)
        .then((response) => response.json())
        .then(async (res) => {
          if (res.code === 200) {
            setISError(false);
            const { user_id, token } = res.data;
            await fetch(getAllUsers + `/${user_id}`, {
              headers: {
                "Content-Type": "application/json",
                appversion: var_app_version,
              },
            })
              .then((response) => response.json())
              .then((res) => {
                if (res.code === 200) {
                  const {
                    fName,
                    lName,
                    id,
                    number,
                    adds,
                    building_count,
                    company,
                    email,
                    role,
                  } = res.data[0];
                  setUser({
                    firstName: fName,
                    lastName: lName,
                    email: email,
                    mobileNumber: number,
                    role: role,
                    uuid: id,
                    company,
                    building_count,
                    address: adds,
                    user_id,
                    token,
                  });
                  //Run route
                  homescreen.replace("/scheduler-home");
                  localStorage.setItem(
                    "user",
                    JSON.stringify({
                      firstName: fName,
                      lastName: lName,
                      email: email,
                      mobileNumber: number,
                      role: role,
                      uuid: id,
                      company,
                      building_count,
                      address: adds,
                      user_id,
                      token,
                    }),
                  );
                  //Storing this to keep track of scheduler while impersonating the customer
                  localStorage.setItem(
                    "scheduler_user",
                    JSON.stringify({
                      firstName: fName,
                      lastName: lName,
                      email: email,
                      mobileNumber: number,
                      role: role,
                      uuid: id,
                      company,
                      building_count,
                      address: adds,
                      user_id,
                      token,
                    }),
                  );
                } else {
                  if (res?.version && res?.version !== var_app_version) {
                    set_is_app_version_outdated(true);
                  }
                  setValidationError("Error while getting user");
                  setISError(true);
                }
              })
              .catch((error) => {
                console.error("Error:", error);
              });
            setLoading(false);
          } else {
            const { success, failed } = res;
            if (res?.version && res?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
            if (success) {
              setValidationError(success);
              setISError(true);
            } else if (failed) {
              setValidationError(failed);
              setISError(true);
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.error("Error:", error);
        });
    }
  };

  /* RENDER APP
	---------------------------------------------------------------------------------*/

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <div className="login-card-header">
          <img src={logo} alt="PestPac API" />
        </div>
        <div className="loing-card-body">
          <Form
            className="login-form"
            error={isError}
            onSubmit={() => onSubmit()}
          >
            <Form.Group>
              <Form.Field
                id="email"
                name="email"
                label="Email"
                disabled={isLoading}
                required
                control={Input}
                onChange={onChangeEmail}
              />
            </Form.Group>
            <Form.Group>
              <Form.Field
                id="password"
                name="password"
                label="Password"
                disabled={isLoading}
                control={Input}
                type="password"
                required
                onChange={onChangePassword}
              />
            </Form.Group>
            <Message error header="Error" content={validation_error} />
            <Button
              className="button-form-submit"
              color="red"
              type="submit"
              loading={isLoading}
              disabled={isLoading}
            >
              SIGN IN
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default Login;
